// ── 机构互动信号 — 读取 investor_project_signals ─────────────────────
// 数据由 scripts/match-investor-signals.mjs 定期跑批写入（不是实时查询 Twitter）。
// 供三处使用：早期雷达/零融资热榜卡片上的"机构关注中"标记，KOL雷达的互动动向面板。
import { supabase } from '../lib/supabase';

/**
 * 按项目 twitter handle 批量查有没有机构互动信号。
 * @param {string[]} handles - 不带 @ 的 twitter handle 列表
 * @returns {Promise<Record<string, object[]>>} handle(小写) -> 该项目的信号列表
 */
export async function fetchSignalsForHandles(handles) {
  const clean = [...new Set((handles || []).filter(Boolean).map((h) => h.toLowerCase()))];
  if (!supabase || clean.length === 0) return {};

  const { data, error } = await supabase
    .from('investor_project_signals')
    .select('investor_handle,investor_type,project_name,project_twitter_handle,interaction_type,tweet_text,tweet_created_at')
    .in('project_twitter_handle', clean)
    .order('tweet_created_at', { ascending: false });
  if (error || !data) return {};

  const map = {};
  data.forEach((row) => {
    const key = row.project_twitter_handle.toLowerCase();
    (map[key] = map[key] || []).push(row);
  });
  return map;
}

/**
 * 最近的机构互动动向——KOL雷达新面板用，不按项目筛选，按时间倒序。
 * @param {number} [limit=30]
 * @returns {Promise<object[]>}
 */
export async function fetchRecentSignals(limit = 30) {
  if (!supabase) return [];
  const { data, error } = await supabase
    .from('investor_project_signals')
    .select('investor_handle,investor_type,project_name,project_source,project_twitter_handle,interaction_type,tweet_text,tweet_created_at')
    .order('tweet_created_at', { ascending: false })
    .limit(limit);
  if (error || !data) return [];
  return data;
}
